const topLineCharts = [{
	"column": "SettleAmount",
	"axisTitle": "总金额",
	"color": "#31859C",
	"position": "left",
	"checked": false,
	"isShow": false
}, {
	"column": "Kilometre",
	"axisTitle": "公里数",
	"color": "#9BBB59",
	"position": "left",
	"checked": true,
	"isShow": true
}, {
	"column": "Qty",
	"axisTitle": "订单量",
	"color": "#F79646",
	"position": "right",
	"checked": true,
	"isShow": true
}]

const bottomLineCharts = [{
	"column": "Price",
	"axisTitle": "均单价",
	"color": "#FF4D4F",
	"position": "right",
	"checked": false,
	"isShow": true
}, {
	"column": "KPrice",
	"axisTitle": "均公里价",
	"color": "#804040",
	"position": "right",
	"checked": true,
	"isShow": true
}]

export {
	topLineCharts,
	bottomLineCharts
}
